import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faInfoCircle } from '@fortawesome/pro-solid-svg-icons/faInfoCircle';

import React, { useState } from 'react';

import PropTypes from 'prop-types';

import { ModalPortal } from '../../components/modal-portal';
import { ThirdPDOModal } from '../third-pdo-modal';
import style from './style.module.css';

export const ThirdPartyDeliveryOptionsButton = ({ storeGuid, thirdPartyDeliveryNumber, orderNumber }) => {
  const [isThirdPartyDeliveryOptionsModalOpen, setIsThirdPartyDeliveryOptionsModalOpen] = useState(false);

  const openThirdPartyDeliveryOptionsModal = () => setIsThirdPartyDeliveryOptionsModalOpen(true);
  const closeThirdPartyDeliveryOptionsModal = () => setIsThirdPartyDeliveryOptionsModalOpen(false);

  return (
    <>
      <button className={style['target-icon']} onClick={openThirdPartyDeliveryOptionsModal}>
        <FontAwesomeIcon icon={faInfoCircle} />
      </button>
      {isThirdPartyDeliveryOptionsModalOpen && (
        <ModalPortal onClose={closeThirdPartyDeliveryOptionsModal}>
          <ThirdPDOModal
            onClose={closeThirdPartyDeliveryOptionsModal}
            orderNumber={orderNumber}
            storeGuid={storeGuid}
            thirdPartyDeliveryNumber={thirdPartyDeliveryNumber}
          />
        </ModalPortal>
      )}
    </>
  );
};

ThirdPartyDeliveryOptionsButton.propTypes = {
  storeGuid: PropTypes.string.isRequired,
  thirdPartyDeliveryNumber: PropTypes.string.isRequired,
  orderNumber: PropTypes.string.isRequired,
};
